

export function setTitle(title: string) {
  const container = document.getElementById('page-title');
  if (container) {
    container.innerText = title;
    document.title = `${title} - ${container.dataset.appName}`;
  } else {
    console.debug("Title didn't exist somehow.");
  }
}

export function setActiveNav() {
  const divs = document.querySelectorAll<HTMLDivElement>('nav.main-menu div.item.active');
  for (let i = 0; i < divs.length; ++i) {
    divs[i].classList.toggle('active', false);
  }
  const navLinks = document.querySelectorAll<HTMLAnchorElement>('nav.main-menu a:not(.disabled)');
  for (let i = 0; i < navLinks.length; ++i) {
    const link = navLinks[i];
    if (link.pathname.length === 0) continue;

    const isLinkActive = window.location.pathname === link.pathname;
    link.classList.toggle('active', isLinkActive);

    if (isLinkActive) {
      link.closest('div.item')?.classList?.toggle('active', true);
    }
  }
}

type Breadcrumb = {
  name: string,
  route?: string
}

export function setBreadcrumbs(breadcrumbs: Array<Breadcrumb>) {
  const createSeparator = () => {
    const i = document.createElement('i');
    i.classList.add('mdi', 'mdi-slash-forward', 'text-base', 'px-1');
    return i;
  }

  const createBreadcrumb = (breadcrumb: Breadcrumb): HTMLElement => {
    if (breadcrumb.route) {
      const anchor = document.createElement('a');
      anchor.href = breadcrumb.route;
      anchor.innerText = breadcrumb.name;
      return anchor;
    }
    const span = document.createElement('span');
    span.innerText = breadcrumb.name;
    return span;
  }

  const container = document.getElementById('breadcrumbs-container');
  if (container) {
    container.innerText = '';
    for (let i = 0; i < breadcrumbs.length; i++) {
      const breadcrumb = breadcrumbs[i];
      container.appendChild(createBreadcrumb(breadcrumb));
      if (i < breadcrumbs.length - 1) {
        container.appendChild(createSeparator());
      }
    }
  } else {
    console.debug("Breadcrumbs didn't exist somehow.");
  }

}